import { useEffect, useState } from 'react';
import { Label, RadioGroup } from 'tombac';
import "./SettingsForm.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useRadioInput = defaultValue => {
  const [value, setValue] = useState(defaultValue);
  return {
    value,
    onChange: setValue
  };
};
export const settingsFormDefaultValues = {
  units: 'KM',
  clockFormat: '24',
  weekStart: 'MONDAY',
  dateFormat: 'DDMMYYYY'
};
function SettingsForm({
  defaultValue = settingsFormDefaultValues,
  onChange
}) {
  const unitsInput = useRadioInput(defaultValue.units);
  const clockInput = useRadioInput(defaultValue.clockFormat);
  const dateInput = useRadioInput(defaultValue.dateFormat);
  const weekInput = useRadioInput(defaultValue.weekStart);
  useEffect(() => {
    onChange({
      units: unitsInput.value,
      clockFormat: clockInput.value,
      weekStart: weekInput.value,
      dateFormat: dateInput.value
    });
  }, [unitsInput.value, clockInput.value, dateInput.value, weekInput.value]);
  return /*#__PURE__*/_jsxs("div", {
    className: "SettingsForm",
    "data-sentry-component": "SettingsForm",
    "data-sentry-source-file": "SettingsForm.tsx",
    children: [/*#__PURE__*/_jsx(Label, {
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "Label",
      children: "Units"
    }), /*#__PURE__*/_jsx(RadioGroup, {
      getOptionLabel: option => option,
      getOptionValue: option => option,
      options: ['KM', 'MI'],
      variant: "horizontal",
      ...unitsInput,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "RadioGroup"
    }), /*#__PURE__*/_jsx(Label, {
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "Label",
      children: "Clock format"
    }), /*#__PURE__*/_jsx(RadioGroup, {
      getOptionLabel: option => option,
      getOptionValue: option => option,
      options: ['24', '12'],
      variant: "horizontal",
      ...clockInput,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "RadioGroup"
    }), /*#__PURE__*/_jsx(Label, {
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "Label",
      children: "Date format"
    }), /*#__PURE__*/_jsx(RadioGroup, {
      getOptionLabel: option => option,
      getOptionValue: option => option,
      options: ['DDMMYYYY', 'MMDDYYYY'],
      variant: "horizontal",
      ...dateInput,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "RadioGroup"
    }), /*#__PURE__*/_jsx(Label, {
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "Label",
      children: "Week starts"
    }), /*#__PURE__*/_jsx(RadioGroup, {
      getOptionLabel: option => option,
      getOptionValue: option => option,
      options: ['MONDAY', 'SUNDAY'],
      variant: "horizontal",
      ...weekInput,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "SettingsForm.tsx",
      "data-sentry-element": "RadioGroup"
    })]
  });
}
export default SettingsForm;